import COLORS from '@/constants/colors';

export const placeholderStyle = {
  '& .MuiInputBase-input::placeholder': {
    color: COLORS.gray_500,
    opacity: '1',
    borderColor: COLORS.gray_300,
  },
};
